import { Component, computed, input, Signal } from '@angular/core';
import { TableColumn } from '../../models/table-column';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'tr[app-table-empty-message-row]',
  imports: [],
  templateUrl: './table-empty-message-row.component.html',
  styleUrls: ['./table-empty-message-row.component.scss'],
})
export class TableEmptyMessageRowComponent<Item, Filter> {
  public readonly reordering = input.required<boolean>();
  public readonly columns = input.required<TableColumn<Item, Filter>[]>();
  public readonly columnsCount = this.columnsCountSignal();

  private columnsCountSignal(): Signal<number> {
    return computed(() => {
      const columnsCount = this.columns().length;

      if (this.reordering()) {
        const additionalColumnsCount = ['reorder', 'filler', 'actions'];

        return columnsCount + additionalColumnsCount.length;
      }

      const additionalColumnsCount = ['filler', 'actions'];

      return columnsCount + additionalColumnsCount.length;
    });
  }
}
